/**
 * Created by kb on 2017/12/20.
 */
import Vue from 'vue'
import  { menuPage} from  '@/commonJs/commonconf';
import  { util } from  '@/commonJs/util'
import store from '../store'

let  MyPlugin;
// xxx.js 组件
   MyPlugin = function install (Vue, options) {


     let WhiteModulelist= ['customer',]

     function  NotPermission(module) {
       return WhiteModulelist.filter(value => {
           return value === module;
         }).length > 0
     }
     //全局方法
     /**
      * 判断按钮是否有权限
      * @param btnName  按钮名称
      */
     Vue.prototype.$_hasPermission = function (btnName) {
       if(NotPermission(menuPage.loginUser.module)) {
         return true
       }
       let menuBtns = store.getters.PagePermissions;
       return menuBtns.has_permission(btnName);
     };

     //判断对象或字符串是否不为空 或未定义
     Vue.prototype.$_notBlank = function (str) {
       return util.notBlank(str);
     };
     /**
      * 自定义权限指令
      */
     Vue.directive("hasPermission", {
       bind: function (el,binding) {
         if (!Vue.prototype.$_hasPermission(binding.value)) {
           // el.parentNode.removeChild(el);
           $(el).remove();
         }
       }
     })
   };
export  default MyPlugin;



// WEBPACK FOOTER //
// ./src/commonJs/Vue_install.js